import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { tap, finalize } from "rxjs/operators";
import {
  AngularFireStorage,
  AngularFireUploadTask,
} from "@angular/fire/storage";
import { AngularFirestore } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { CargaArchivoDTO } from "src/app/models/dtos/carga-archivo-dto";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";
import { LoaderService } from "src/app/services/loader.service";

@Component({
  selector: "cargador-archivo-evidencia",
  templateUrl: "./cargador-archivo-evidencia.component.html",
  styleUrls: ["./cargador-archivo-evidencia.component.scss"],
})
export class CargadorArchivoEvidenciaComponent implements OnInit {
  @Input() datos: CargaArchivoDTO;
  @Output()
  public cargaFinalizada = new EventEmitter<ArchivoCoordenada>();

  task: AngularFireUploadTask;

  percentage: Observable<number>;
  snapshot: Observable<any>;
  downloadURL: string;

  constructor(
    private storage: AngularFireStorage,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.empezarCarga();
  }

  public empezarCarga(): void {
    try {
      let fechaActual: number = new Date().getTime();
      // La ruta del storage
      /**
       * KeyLevantamientoObra/keyCapa/keySegmento/keyCoordenada/fecha_en_timestamp_nombre_archivo
       */

      const path = `obras/${this.datos.keyLevantamientoObra}/capas/${this.datos.keyCapa}/segmentos/${this.datos.keySegmento}/coordenadas/${this.datos.keyCoordenada}/${fechaActual}_${this.datos.archivo.name}`;
      // Referencia al storage
      const ref = this.storage.ref(path);

      // Tarea principal
      this.task = this.storage.upload(path, this.datos.archivo);

      // Monitoreo de progreso
      this.percentage = this.task.percentageChanges();

      this.snapshot = this.task.snapshotChanges().pipe(
        // La url de descarga del archivo
        finalize(async () => {
          this.downloadURL = await ref.getDownloadURL().toPromise();
          let archivoCoordenada: ArchivoCoordenada = {
            nombre: this.datos.archivo.name,
            urlDescarga: this.downloadURL,
            rutaStorage: path,
            fechaCreacion: fechaActual,
            fechaActualizacion: fechaActual,
            descripcion: this.datos.descripcion,
            peso: this.datos.archivo.size,
            tipo: this.datos.tipo,
            keyCatCapa: Number(this.datos.keyCatCapa),
            keyCapa: this.datos.keyCapa,
            keyCoordenada: this.datos.keyCoordenada,
            keyLevantamientoObra: this.datos.keyLevantamientoObra,
            keySegmento: this.datos.keySegmento,
          };
          await this.archivoCoordenadaService.save(archivoCoordenada);
          this.cargaFinalizada.emit(archivoCoordenada);
        })
      );
    } catch (err) {
      console.error(
        "Ocurrió un error al cargar el archivo:",
        this.datos.archivo.name
      );
      this.cargaFinalizada.emit(null);
      this.loaderService.desactivarLoaderScreen();
    }
  }

  isActive(snapshot) {
    return (
      snapshot.state === "running" &&
      snapshot.bytesTransferred < snapshot.totalBytes
    );
  }
}
